<template>
  <v-app>
    <v-content>
      <v-container>
        <v-card
          class="mx-auto pa-2 mb-4 text-center"
          flat
          max-width="500"
        >
          <v-form
            class="my-6"
            ref="form"
            @submit.prevent="submit"
          >
            <v-text-field
              label="Enter an URL"
              v-model="url"
              required
              outlined
              :rules="[rules.required, rules.url]"
            />

            <v-btn
              color="primary"
              type="submit"
            >
              Get images
            </v-btn>

            <v-btn
              type="button"
              class="ml-4"
              outlined
              color="primary"
              v-if="result && result.requestId"
              @click="download()"
            >
              Download All
            </v-btn>
          </v-form>
        </v-card>

        <ErrorAlert
          :error="error"
        />

        <v-row v-if="result">
          <v-col
            v-for="({ src, alt }) in result.images"
            :key="src"
            cols="12"
            sm="4"
            md="3"
          >
            <ImageCard
              :src="src"
              :alt="alt"
            />
          </v-col>
        </v-row>
      </v-container>

      <LoadingOverlay v-if="loading" />
    </v-content>
  </v-app>
</template>

<script>
import validationRules from '../validation-rules.js'
import { extractImages, downloadImages } from '../services/api.js'
import { downloadBlob } from '../services/utils.js'
import ErrorAlert from '@/components/ErrorAlert.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import ImageCard from '@/components/extract-images/ImageCard.vue'

export default {
  name: 'ExtractWordCount',
  components: { ErrorAlert, LoadingOverlay, ImageCard },
  data: () => ({
    loading: false,
    url: null,
    result: null,
    error: null,
    rules: validationRules,
  }),
  methods: {
    async submit() {
      this.error = null
      this.result = null

      if (this.$refs.form.validate()) {
        // this.loading = true

        try {
          const { data } = await extractImages({ url: this.url })
          this.result = data
        } catch (error) {
          this.error = error
        } finally {
          this.loading = false
        }
      }
    },
    async download() {
      try {
          const { data } = await downloadImages({
            requestId: this.result.requestId,
          })

          downloadBlob(new Blob([data]), 'images.zip')
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    }
  },
}
</script>

<style>
.v-application--wrap {
  min-height: auto;
}
</style>
